export const cardFees = {
    transparent: false,
};
